import React, { useState, useEffect, useRef } from 'react';
import Alertas from './Alertas';
import { auth, db } from '../firebase/firebaseConfig';
import { getDocs, collection, where, query, updateDoc, doc, onSnapshot, writeBatch } from 'firebase/firestore';
import { BotonGuardar } from '../elementos/General';
import { Contenido, Input } from '../elementos/CrearEquipos';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { Table, TableBody, Segment, Icon, Button, Modal, Container, Header, Popup, Label, Message } from 'semantic-ui-react'
import moment from 'moment';
import ModalPdf from './Modal';
import { Link } from 'react-router-dom';
// import EnviarCorreo from '../funciones/EnviarCorreo';
// import ReactDOMServer from 'react-dom/server';
import { PDFViewer } from "@react-pdf/renderer";
import Presupuesto from './ReportePresupuestoPDF';
import EvaluacionCabDB from '../firebase/EvaluacionCabDB';
import Swal from 'sweetalert2';

const AsignadosTecnicos = () => {
    //fecha hoy
    const fechaHoy = new Date();
    const user = auth.currentUser;
    const { users } = useContext(UserContext);

    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [asignar, setAsignar] = useState([]);
    const [estadoModal, setEstadoModal] = useState(false);
    const [modal, setModal] = useState(false);
    const [mostrarDet, setMostrarDet] = useState(false);
    const [testIngreso, setTestIngreso] = useState([]);
    const [testEvaluacion, setTestEvaluacion] = useState([]);
    // const [alertaOrdenIngreso, setAlertaOrdenIngreso] = useState([]);
    const [flag, setFlag] = useState(false);
    const [cabecera, setCabecera] = useState([]);
    const [presup, setPresu] = useState([]);
    const [falla, setFalla] = useState([]);
    const [obs, setObs] = useState([]);
    const [total, setTotal] = useState(0);
    const [openPdf, setOpenPdf] = useState(false);
    const [userAdd, setUsersAdd] = useState([]);
    const [usuarioIngreso, setUsuarioIngreso] = useState([]);
    const [presupuestosCabMap, setPresupuestosCabMap] = useState({});


    const idCab = useRef();
    const checktestev = useRef();

    // Leer datos de cabecera Entradas
    const getIngresostcab = async () => {
        if (!users) return;
        const traerCabecera = collection(db, 'ingresostcab');
        const dato = query(traerCabecera, where('emp_id', '==', users.emp_id), where('estado', '==', 'ASIGNADO'), where('tecnico', '==', users.correo));
        const data = await getDocs(dato)
        setAsignar(data.docs.map((doc, index) => ({ ...doc.data(), id: doc.id, id2: index + 1 })))
    }
    const mantoprev = asignar.filter(mp => mp.servicio === 'MANTENCION PREVENTIVA');
    const asignarOrdmp = mantoprev.sort((a, b) => a.folio - b.folio);
    const presu = asignar.filter(p => p.servicio === 'PRESUPUESTO' || p.servicionew === 'PRESUPUESTO');
    const asignarOrdp = presu.sort((a, b) => a.folio - b.folio);
    const evaluacion = asignar.filter(e => (e.servicio === 'EVALUACION Y DIAGNOSTICO' || e.servicio === 'EVALUACION POR GARANTIA') && e.servicionew !== 'PRESUPUESTO');
    const asignarOrde = evaluacion.sort((a, b) => a.folio - b.folio);

    // Leer datos de cabecera Entradas
    const leerIngresoCab = async (id) => {
        const docum = asignar.filter(leer => leer.id === id);
        setMostrarDet(docum);
    }
    // Cambiar fecha
    const formatearFecha = (fecha) => {
        const dateObj = fecha.toDate();
        const formatear = moment(dateObj).format('DD/MM/YYYY HH:mm');
        // const fechaHoyF = moment(fechaHoy).format('DD/MM/YYYY HH:mm');
        return formatear;
    }
    const leerTestIngreso = async (id) => {
        if (!users) return;
        const traer = collection(db, 'testingreso');
        const doc = query(traer, where('id_cab_inst', '==', id));
        const documento = await getDocs(doc)
        setTestIngreso(documento.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    testIngreso.sort((a, b) => a.fechamod - b.fechamod)
    const leerTestEvaluacion = async (id) => {
        if (!users) return;
        const traer = collection(db, 'testevaluacion');
        const doc = query(traer, where('id_cab_inst', '==', id));
        const documento = await getDocs(doc)
        setTestEvaluacion(documento.docs.map((doc) => ({ ...doc.data(), id: doc.id, valorevsi: false, valorevno: false, })))
    }
    testEvaluacion.sort((a, b) => a.fechaadd - b.fechaadd)

    //Consultar usuario
    const consultarUsuario = async () => {
        const user = query(collection(db, 'usuarios'), where('emp_id', '==', users.emp_id));
        const userd = await getDocs(user);
        const traeuser = (userd.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setUsuarioIngreso(traeuser);
    }

    const verPdf = async (id) => {
        try {
            //Leer datos de cabecera
            const datosFiltrados = asignar.filter(item => item.id === id);
            setCabecera(datosFiltrados);

            //Leer cabecera de presupuesto
            const preCab = query(collection(db, 'presupuestoscab'), where('emp_id', '==', users.emp_id), where('id_cab_inst', '==', id));
            const presuCab = await getDocs(preCab);
            const existePreCab = (presuCab.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            idCab.current = existePreCab[0].id;
            setObs(existePreCab[0].obs)

            // Detalle de Ingreso de equipo => Funcional
            const pre = query(collection(db, 'presupuestos'), where('emp_id', '==', users.emp_id), where('id_cab_pre', '==', idCab.current));
            const presus = await getDocs(pre);
            const existePresupuesto = (presus.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            setPresu(existePresupuesto.filter(p => p.categoria === 'REPUESTO' || p.categoria === 'SERVICIO'));
            setFalla(existePresupuesto.filter(f => f.categoria === 'FALLA'));
            // setTotal(existePresupuesto.reduce((total, dato) => total + dato.price, 0));
            setTotal(
                existePresupuesto.reduce((total, dato) => total + parseFloat(dato.price || 0), 0)
            );

            // console.log(existePresupuesto)
            // Verificar que los datos existan antes de extraer useradd
            if (existePreCab.length > 0) {
                const useradd = existePreCab[0].usermod;
                const usuarioFiltrado = usuarioIngreso.filter(
                    (usuario) => usuario.correo === useradd
                );
                setUsersAdd(usuarioFiltrado);
            }

        } catch (error) {
            console.error('Error al obtener los datos del presupuesto:', error);
        }
        setOpenPdf(true);
    }

    const handleButtonClickg = (itemId, option) => {
        const updatedProt = testEvaluacion.map(item => {
            if (item.id === itemId) {
                return {
                    ...item,
                    valorevsi: option === 'opcion1' ? true : false,
                    valorevno: option === 'opcion2' ? true : false,
                    // revision: option === 'opcion3' ? true : false
                }
            }
            return item;
        })
        setTestEvaluacion(updatedProt)
    };

    // cabecera de evaluacion tecnico = Funcional
    const evaluacionCab = async (item) => {
        // e.preventDefault();
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        // Filtar por docuemto de Cabecera de Ingreso para guardar el id de cabecera y Date
        const cab = query(collection(db, 'evaluacioncab'), where('emp_id', '==', users.emp_id), where('folio', '==', item.folio));
        const cabecera = await getDocs(cab);
        const existeCab = (cabecera.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

        if (existeCab.length > 0) {
            console.log('Ya existe un documento con este folio');
            // return
        } else {
            try {
                EvaluacionCabDB({
                    id_cab_inst: item.id,
                    folio: item.folio,
                    servicio: item.servicio,
                    servicionew: null,
                    fecha_servicionew: null,
                    tecnico: user.email,
                    confirmado: false,
                    userAdd: user.email,
                    userMod: user.email,
                    fechaAdd: fechaHoy,
                    fechaMod: fechaHoy,
                    emp_id: users.emp_id,
                })
            } catch (error) {
                cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'error',
                    mensaje: error
                })
            }
            setFlag(!flag)
        }
    }

    // Boton Guardar evaluacion de tecnico de Garntia => Pendiente => Solo guarda los items con valores
    const guardarTest = async (e) => {
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        // Filtar por docuemto de Cabecera de Ingreso para guardar el id de cabecera y Date
        const cab = query(collection(db, 'evaluacioncab'), where('emp_id', '==', users.emp_id), where('folio', '==', testEvaluacion[0].folio));
        const cabecera = await getDocs(cab);
        const existeCab = (cabecera.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

        testEvaluacion.forEach((docs, index) => {
            checktestev.current = testEvaluacion.filter(ic => ic.valorevsi === false && ic.valorevno === false)
        });

        if (checktestev.current.length > 0) {
            Swal.fire('Deben estar seleccionados todos los items de Evaluación!');
        } else {
            setModal(false);
            // Crea una nueva instancia de lote (batch)
            const batch = writeBatch(db);
            // Obtiene una referencia a una colección específica en Firestore
            const bitacoraTestRef = collection(db, 'evaluacion');
            // Itera a través de los nuevos documentos y agrégalos al lote de Checks
            testEvaluacion.forEach((docs) => {
                const nuevoDocRef = doc(bitacoraTestRef); // Crea una referencia de documento vacía (Firestore asignará un ID automáticamente)
                batch.set(nuevoDocRef, {
                    id_cab_ev: existeCab[0].id,
                    id_cab_inst: docs.id_cab_inst,
                    folio: docs.folio,
                    item: docs.item,
                    item_id: docs.item_id,
                    valorsi: docs.valorevsi,
                    valorno: docs.valorevno,
                    useradd: user.email,
                    usermod: user.email,
                    fechaadd: fechaHoy,
                    fechamod: fechaHoy,
                    emp_id: users.emp_id,
                });
            });

            batch.commit()
                .then(() => {
                    setTimeout(() => {
                        cambiarEstadoAlerta(true);
                        cambiarAlerta({
                            tipo: 'exito',
                            mensaje: 'Documento creado correctamente.'
                        });
                    }, 3000);
                })
                .catch((error) => {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Error al guardar Test de Ingreso:', error
                    })
                })

            if (testEvaluacion.filter(ic => ic.valorevsi === true).length > 0) {
                try {
                    await updateDoc(doc(db, 'evaluacioncab', existeCab[0].id), {
                        confirmado: true,
                        servicionew: 'PRESUPUESTO',
                        usermod: user.email,
                        fechamod: fechaHoy,
                        fecha_servicionew: fechaHoy
                    });
                } catch (error) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Error al actualizar cabecera de Ingreso:', error
                    })
                }
                try {
                    await updateDoc(doc(db, 'ingresostcab', testEvaluacion[0].id_cab_inst), {
                        servicionew: 'PRESUPUESTO',
                        fecha_servicionew: fechaHoy,
                        estado_servicio: 'EVALUADO',
                        usermod: user.email,
                        fechamod: fechaHoy
                    });
                } catch (error) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Error al actualizar cabecera de Ingreso:', error
                    })
                }
            } else {
                try {
                    await updateDoc(doc(db, 'evaluacioncab', existeCab[0].id), {
                        confirmado: true,
                        servicionew: 'GARANTIA',
                        usermod: user.email,
                        fechamod: fechaHoy,
                        fecha_servicionew: fechaHoy
                    });
                } catch (error) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Error al actualizar cabecera de Ingreso:', error
                    })
                }
                try {
                    await updateDoc(doc(db, 'ingresostcab', testEvaluacion[0].id_cab_inst), {
                        servicionew: 'GARANTIA',
                        fecha_servicionew: fechaHoy,
                        estado_servicio: 'EVALUADO',
                        usermod: user.email,
                        fechamod: fechaHoy
                    });
                } catch (error) {
                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                        tipo: 'error',
                        mensaje: 'Error al actualizar cabecera de Ingreso:', error
                    })
                }
            }
        }
        setFlag(!flag)
    }

    useEffect(() => {

        if (!users?.correo || !users?.emp_id) return; // Evita error si aún no carga el contexto

        const queri = query(collection(db, 'ingresostcab'),
            where('emp_id', '==', users.emp_id),
            where('estado', '==', 'ASIGNADO'),
            where('tecnico', '==', users.correo)
        );

        const unsubscribe = onSnapshot(queri, (snapshot) => {
            const data = snapshot.docs.map((doc, index) => ({
                id: doc.id,
                id2: index + 1,
                ...doc.data()
            }));
            setAsignar(data);
        });

        return () => unsubscribe();


    }, [users.correo, users.emp_id]);

    useEffect(() => {
        getIngresostcab();
        // getAlertasOrdenIngreso();
        consultarUsuario();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users])

    useEffect(() => {
        getIngresostcab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag, setFlag])

    useEffect(() => {
        if (!users?.emp_id) return;

        const q = query(
            collection(db, "presupuestoscab"),
            where("emp_id", "==", users.emp_id)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const mapa = {};

            snapshot.docs.forEach((d) => {
                const data = d.data();

                if (data.id_cab_inst) {
                    mapa[data.id_cab_inst] = {
                        id: d.id,
                        ...data
                    };
                }
            });

            setPresupuestosCabMap(mapa);
        });

        return () => unsubscribe();
    }, [users?.emp_id]);

    return (
        <Container
            fluid
            style={{
                background: "#f8fafc",
                minHeight: "100vh",
                padding: "18px 16px 35px",
            }}
        >
            <Container fluid style={{ maxWidth: 1400 }}>

                {/* ================= CABECERA ================= */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: "18px 20px",
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                        <Label
                            size="massive"
                            style={{
                                background: "#e8f8f7",
                                color: "#00b5ad",
                                margin: 0,
                            }}
                        >
                            <Icon name="user wrench" style={{ margin: 0 }} />
                        </Label>

                        <Header
                            as="h2"
                            style={{
                                margin: 0,
                                color: "#1f2937",
                                fontSize: 21,
                            }}
                        >
                            Trabajos asignados
                            <Header.Subheader style={{ marginTop: 5 }}>
                                Técnico: {users?.nombre} {users?.apellido}
                            </Header.Subheader>
                        </Header>
                    </div>
                </Segment>

                {/* ================= RESUMEN ================= */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        marginBottom: 16,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: 12,
                            flexWrap: "wrap",
                        }}
                    >
                        <Label basic color="teal" size="large">
                            <Icon name="wrench" />
                            Preventivas
                            <Label.Detail>
                                {asignarOrdmp?.length || 0}
                            </Label.Detail>
                        </Label>

                        <Label basic color="teal" size="large">
                            <Icon name="file alternate outline" />
                            Presupuestos
                            <Label.Detail>
                                {asignarOrdp?.length || 0}
                            </Label.Detail>
                        </Label>

                        <Label basic color="teal" size="large">
                            <Icon name="shield alternate" />
                            Garantías
                            <Label.Detail>
                                {asignarOrde?.length || 0}
                            </Label.Detail>
                        </Label>
                    </div>
                </Segment>

                {/* ============================================================
                MANTENCIÓN PREVENTIVA
            ============================================================ */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: 0,
                        overflow: "hidden",
                        marginBottom: 16,
                    }}
                >
                    <div
                        style={{
                            padding: "14px 16px",
                            borderBottom: "1px solid #e5e7eb",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <Header as="h3" style={{ margin: 0, fontSize: 17 }}>
                            <Icon name="wrench" color="teal" />
                            <Header.Content>
                                Mantención Preventiva
                                <Header.Subheader>
                                    Equipos asignados para mantenimiento programado
                                </Header.Subheader>
                            </Header.Content>
                        </Header>

                        <Label basic color="teal">
                            {asignarOrdmp?.length || 0} pendiente(s)
                        </Label>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: 420,
                        }}
                    >
                        <Table
                            celled
                            striped
                            selectable
                            compact="very"
                            singleLine
                            style={{ fontSize: 12, margin: 0 }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">
                                        #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>Orden</Table.HeaderCell>
                                    <Table.HeaderCell>Ingreso</Table.HeaderCell>
                                    <Table.HeaderCell>Cliente</Table.HeaderCell>
                                    <Table.HeaderCell>Equipo</Table.HeaderCell>
                                    <Table.HeaderCell>Modelo</Table.HeaderCell>
                                    <Table.HeaderCell>N° Serie</Table.HeaderCell>
                                    <Table.HeaderCell>Servicio</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Detalle
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Ejecutar
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {asignarOrdmp?.map((item, index) => (
                                    <Table.Row key={item.id ?? index}>
                                        <Table.Cell textAlign="center">
                                            {index + 1}
                                        </Table.Cell>

                                        <Table.Cell style={{ fontWeight: 600 }}>
                                            {item.folio}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {formatearFecha(item.date)}
                                        </Table.Cell>

                                        <Table.Cell
                                            title={item.entidad}
                                            style={{
                                                maxWidth: 220,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {item.entidad}
                                        </Table.Cell>

                                        <Table.Cell
                                            title={item.tipo}
                                            style={{
                                                maxWidth: 200,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {item.tipo}
                                        </Table.Cell>

                                        <Table.Cell>{item.modelo}</Table.Cell>
                                        <Table.Cell>{item.serie}</Table.Cell>

                                        <Table.Cell>
                                            <Label basic color="teal" size="tiny">
                                                {item.servicio}
                                            </Label>
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Popup
                                                content="Ver documento de ingreso"
                                                trigger={
                                                    <Button
                                                        basic
                                                        compact
                                                        icon
                                                        size="mini"
                                                        onClick={() => {
                                                            leerIngresoCab(item.id);
                                                            leerTestIngreso(item.id);
                                                            setEstadoModal(true);
                                                        }}
                                                        style={{
                                                            color: "#2185d0",
                                                            background: "#fff",
                                                            boxShadow: "none",
                                                        }}
                                                    >
                                                        <Icon
                                                            name="eye outline"
                                                            color="blue"
                                                            style={{
                                                                margin: 0,
                                                                fontSize: "1.2em",
                                                            }}
                                                        />
                                                    </Button>
                                                }
                                            />
                                        </Table.Cell>

                                        <Table.Cell textAlign="center">
                                            <Popup
                                                content="Ejecutar mantención"
                                                trigger={
                                                    <Button
                                                        compact
                                                        icon
                                                        size="mini"
                                                        color="teal"
                                                        as={Link}
                                                        to={`/ejecutarmantencionst/${item.id}`}
                                                    >
                                                        <Icon
                                                            name="play circle"
                                                            style={{ margin: 0 }}
                                                        />
                                                    </Button>
                                                }
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}

                                {(!asignarOrdmp ||
                                    asignarOrdmp.length === 0) && (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="10"
                                                textAlign="center"
                                                style={{
                                                    padding: 28,
                                                    color: "#6b7280",
                                                }}
                                            >
                                                <Icon
                                                    name="inbox"
                                                    color="grey"
                                                    size="large"
                                                />
                                                <div style={{ marginTop: 6 }}>
                                                    No tienes mantenciones preventivas
                                                    asignadas.
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>

                {/* ============================================================
                PRESUPUESTOS
            ============================================================ */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: 0,
                        overflow: "hidden",
                        marginBottom: 16,
                    }}
                >
                    <div
                        style={{
                            padding: "14px 16px",
                            borderBottom: "1px solid #e5e7eb",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <Header as="h3" style={{ margin: 0, fontSize: 17 }}>
                            <Icon name="file alternate outline" color="teal" />
                            <Header.Content>
                                Presupuestos
                                <Header.Subheader>
                                    Generación, aprobación y ejecución de presupuestos
                                </Header.Subheader>
                            </Header.Content>
                        </Header>

                        <Label basic color="teal">
                            {asignarOrdp?.length || 0} pendiente(s)
                        </Label>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: 500,
                        }}
                    >
                        <Table
                            celled
                            striped
                            selectable
                            compact="very"
                            singleLine
                            style={{ fontSize: 11, margin: 0 }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">
                                        #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>Orden</Table.HeaderCell>
                                    <Table.HeaderCell>Ingreso</Table.HeaderCell>
                                    <Table.HeaderCell>Cliente</Table.HeaderCell>
                                    <Table.HeaderCell>Equipo</Table.HeaderCell>
                                    <Table.HeaderCell>Modelo</Table.HeaderCell>
                                    <Table.HeaderCell>N° Serie</Table.HeaderCell>
                                    <Table.HeaderCell>Inicial</Table.HeaderCell>
                                    <Table.HeaderCell>Nuevo</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Detalle
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Generar
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Acción
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Ejecutar
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        PDF
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {asignarOrdp?.map((item, index) => {
                                    const estado =
                                        item.estado_servicio || "";

                                    const cabPre =
                                        presupuestosCabMap[item.id];

                                    const esBajaST =
                                        cabPre?.tipo_resolucion ===
                                        "BAJA_ST";

                                    const puedeGenerar = !(
                                        estado === "GENERADO" ||
                                        estado === "ENVIADO" ||
                                        estado === "ACEPTADO" ||
                                        estado === "EJECUTANDO"
                                    );

                                    const puedeAccion =
                                        !esBajaST &&
                                        (estado === "GENERADO" ||
                                            estado === "ENVIADO");

                                    const puedeEjecutar = esBajaST
                                        ? estado === "GENERADO" ||
                                        estado === "EJECUTANDO"
                                        : estado === "ACEPTADO" ||
                                        estado === "EJECUTANDO";

                                    const puedePdf = !(
                                        estado === "" ||
                                        estado === "EVALUADO"
                                    );

                                    return (
                                        <Table.Row key={item.id ?? index}>
                                            <Table.Cell textAlign="center">
                                                {index + 1}
                                            </Table.Cell>

                                            <Table.Cell
                                                style={{ fontWeight: 600 }}
                                            >
                                                {item.folio}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {formatearFecha(item.date)}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.entidad}
                                            </Table.Cell>

                                            <Table.Cell>{item.tipo}</Table.Cell>
                                            <Table.Cell>{item.modelo}</Table.Cell>
                                            <Table.Cell>{item.serie}</Table.Cell>

                                            <Table.Cell>
                                                <Label
                                                    basic
                                                    color="grey"
                                                    size="tiny"
                                                >
                                                    {item.servicio}
                                                </Label>
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.servicionew ? (
                                                    <Label
                                                        basic
                                                        color="teal"
                                                        size="tiny"
                                                    >
                                                        {item.servicionew}
                                                    </Label>
                                                ) : (
                                                    "—"
                                                )}
                                            </Table.Cell>

                                            {/* DETALLE */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content="Ver documento de ingreso"
                                                    trigger={
                                                        <Button
                                                            basic
                                                            compact
                                                            icon
                                                            size="mini"
                                                            onClick={() => {
                                                                leerIngresoCab(
                                                                    item.id
                                                                );
                                                                leerTestIngreso(
                                                                    item.id
                                                                );
                                                                setEstadoModal(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            <Icon
                                                                name="eye outline"
                                                                color="blue"
                                                                style={{
                                                                    margin: 0,
                                                                    fontSize:
                                                                        "1.2em",
                                                                }}
                                                            />
                                                        </Button>
                                                    }
                                                />
                                            </Table.Cell>

                                            {/* GENERAR */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content={
                                                        puedeGenerar
                                                            ? "Generar presupuesto"
                                                            : "Ya generado / enviado / aceptado"
                                                    }
                                                    trigger={
                                                        <span>
                                                            <Button
                                                                compact
                                                                icon
                                                                size="mini"
                                                                color="teal"
                                                                disabled={
                                                                    !puedeGenerar
                                                                }
                                                                as={
                                                                    puedeGenerar
                                                                        ? Link
                                                                        : undefined
                                                                }
                                                                to={
                                                                    puedeGenerar
                                                                        ? `/presupuesto/${item.id}`
                                                                        : undefined
                                                                }
                                                            >
                                                                <Icon
                                                                    name="file alternate outline"
                                                                    style={{
                                                                        margin: 0,
                                                                    }}
                                                                />
                                                            </Button>
                                                        </span>
                                                    }
                                                />
                                            </Table.Cell>

                                            {/* ACCIÓN */}
                                            <Table.Cell textAlign="center">
                                                {esBajaST ? (
                                                    <Popup
                                                        content="Baja ST - no requiere envío ni aceptación"
                                                        trigger={
                                                            <Icon
                                                                name="trash alternate"
                                                                color="red"
                                                                size="large"
                                                            />
                                                        }
                                                    />
                                                ) : (
                                                    <>
                                                        {estado ===
                                                            "GENERADO" && (
                                                                <Popup
                                                                    content="Enviar presupuesto"
                                                                    trigger={
                                                                        <Button
                                                                            compact
                                                                            icon
                                                                            size="mini"
                                                                            color="blue"
                                                                            as={Link}
                                                                            to={`/presupuesto/${item.id}`}
                                                                        >
                                                                            <Icon
                                                                                name="paper plane"
                                                                                style={{
                                                                                    margin: 0,
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    }
                                                                />
                                                            )}

                                                        {estado ===
                                                            "ENVIADO" && (
                                                                <Popup
                                                                    content="Aceptar / Rechazar"
                                                                    trigger={
                                                                        <Button
                                                                            compact
                                                                            icon
                                                                            size="mini"
                                                                            color="yellow"
                                                                            as={Link}
                                                                            to={`/presupuesto/${item.id}`}
                                                                        >
                                                                            <Icon
                                                                                name="check"
                                                                                style={{
                                                                                    margin: 0,
                                                                                }}
                                                                            />
                                                                        </Button>
                                                                    }
                                                                />
                                                            )}

                                                        {!puedeAccion &&
                                                            estado !==
                                                            "GENERADO" &&
                                                            estado !==
                                                            "ENVIADO" && (
                                                                <Icon
                                                                    name="minus circle"
                                                                    color="grey"
                                                                />
                                                            )}
                                                    </>
                                                )}
                                            </Table.Cell>

                                            {/* EJECUTAR */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content={
                                                        puedeEjecutar
                                                            ? esBajaST
                                                                ? "Ejecutar Baja ST"
                                                                : "Ejecutar presupuesto"
                                                            : esBajaST
                                                                ? "Primero debe generarse la Baja ST"
                                                                : "Debe estar ACEPTADO"
                                                    }
                                                    trigger={
                                                        <span>
                                                            <Button
                                                                compact
                                                                icon
                                                                size="mini"
                                                                color={
                                                                    esBajaST
                                                                        ? "red"
                                                                        : "green"
                                                                }
                                                                disabled={
                                                                    !puedeEjecutar
                                                                }
                                                                as={
                                                                    puedeEjecutar
                                                                        ? Link
                                                                        : undefined
                                                                }
                                                                to={
                                                                    puedeEjecutar
                                                                        ? `/ejecutarpresupuestost/${item.id}`
                                                                        : undefined
                                                                }
                                                            >
                                                                <Icon
                                                                    name="play circle"
                                                                    style={{
                                                                        margin: 0,
                                                                    }}
                                                                />
                                                            </Button>
                                                        </span>
                                                    }
                                                />
                                            </Table.Cell>

                                            {/* PDF */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content={
                                                        puedePdf
                                                            ? "Ver PDF presupuesto"
                                                            : "No disponible aún"
                                                    }
                                                    trigger={
                                                        <span>
                                                            <Button
                                                                basic
                                                                compact
                                                                icon
                                                                size="mini"
                                                                disabled={
                                                                    !puedePdf
                                                                }
                                                                onClick={
                                                                    puedePdf
                                                                        ? () =>
                                                                            verPdf(
                                                                                item.id
                                                                            )
                                                                        : undefined
                                                                }
                                                                style={{
                                                                    color: puedePdf
                                                                        ? "#db2828"
                                                                        : undefined,
                                                                    background:
                                                                        "#fff",
                                                                    boxShadow:
                                                                        "none",
                                                                }}
                                                            >
                                                                <Icon
                                                                    name="file pdf outline"
                                                                    color={
                                                                        puedePdf
                                                                            ? "red"
                                                                            : "grey"
                                                                    }
                                                                    style={{
                                                                        margin: 0,
                                                                        fontSize:
                                                                            "1.25em",
                                                                    }}
                                                                />
                                                            </Button>
                                                        </span>
                                                    }
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}

                                {(!asignarOrdp ||
                                    asignarOrdp.length === 0) && (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="14"
                                                textAlign="center"
                                                style={{
                                                    padding: 28,
                                                    color: "#6b7280",
                                                }}
                                            >
                                                <Icon
                                                    name="inbox"
                                                    color="grey"
                                                    size="large"
                                                />
                                                <div style={{ marginTop: 6 }}>
                                                    No tienes presupuestos asignados.
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>

                {/* ============================================================
                GARANTÍAS
            ============================================================ */}
                <Segment
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        boxShadow: "0 1px 3px rgba(0,0,0,.06)",
                        padding: 0,
                        overflow: "hidden",
                        marginBottom: 16,
                    }}
                >
                    <div
                        style={{
                            padding: "14px 16px",
                            borderBottom: "1px solid #e5e7eb",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <Header as="h3" style={{ margin: 0, fontSize: 17 }}>
                            <Icon name="shield alternate" color="teal" />
                            <Header.Content>
                                Evaluación por Garantía
                                <Header.Subheader>
                                    Evaluación, garantía local y derivación externa
                                </Header.Subheader>
                            </Header.Content>
                        </Header>

                        <Label basic color="teal">
                            {asignarOrde?.length || 0} pendiente(s)
                        </Label>
                    </div>

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: 460,
                        }}
                    >
                        <Table
                            celled
                            striped
                            selectable
                            compact="very"
                            singleLine
                            style={{ fontSize: 12, margin: 0 }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">
                                        #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>Orden</Table.HeaderCell>
                                    <Table.HeaderCell>Ingreso</Table.HeaderCell>
                                    <Table.HeaderCell>Cliente</Table.HeaderCell>
                                    <Table.HeaderCell>Equipo</Table.HeaderCell>
                                    <Table.HeaderCell>Modelo</Table.HeaderCell>
                                    <Table.HeaderCell>N° Serie</Table.HeaderCell>
                                    <Table.HeaderCell>Servicio</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Detalle
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Evaluar
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        Acción
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {asignarOrde?.map((item, index) => {
                                    const estado =
                                        item.estado_servicio || "";

                                    const esGarantiaExterna =
                                        estado === "GARANTIA_EXTERNA";

                                    const yaEvaluado =
                                        estado === "EVALUADO" ||
                                        estado === "DIAGNOSTICADO" ||
                                        esGarantiaExterna;

                                    const puedeEjecutar = yaEvaluado;

                                    return (
                                        <Table.Row key={item.id ?? index}>
                                            <Table.Cell textAlign="center">
                                                {index + 1}
                                            </Table.Cell>

                                            <Table.Cell
                                                style={{ fontWeight: 600 }}
                                            >
                                                {item.folio}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {formatearFecha(item.date)}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.entidad}
                                            </Table.Cell>

                                            <Table.Cell>{item.tipo}</Table.Cell>
                                            <Table.Cell>{item.modelo}</Table.Cell>
                                            <Table.Cell>{item.serie}</Table.Cell>

                                            <Table.Cell>
                                                <Label
                                                    basic
                                                    color={
                                                        esGarantiaExterna
                                                            ? "violet"
                                                            : "teal"
                                                    }
                                                    size="tiny"
                                                >
                                                    {item.servicionew ===
                                                        "GARANTIA"
                                                        ? "GARANTIA"
                                                        : item.servicio}
                                                </Label>
                                            </Table.Cell>

                                            {/* DETALLE */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content="Ver documento de ingreso"
                                                    trigger={
                                                        <Button
                                                            basic
                                                            compact
                                                            icon
                                                            size="mini"
                                                            onClick={() => {
                                                                leerIngresoCab(
                                                                    item.id
                                                                );
                                                                leerTestIngreso(
                                                                    item.id
                                                                );
                                                                leerTestEvaluacion(
                                                                    item.id
                                                                );
                                                                setEstadoModal(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            <Icon
                                                                name="eye outline"
                                                                color="blue"
                                                                style={{
                                                                    margin: 0,
                                                                    fontSize:
                                                                        "1.2em",
                                                                }}
                                                            />
                                                        </Button>
                                                    }
                                                />
                                            </Table.Cell>

                                            {/* EVALUAR */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content={
                                                        yaEvaluado
                                                            ? "Ya evaluado"
                                                            : "Evaluar"
                                                    }
                                                    trigger={
                                                        <span>
                                                            <Button
                                                                compact
                                                                icon
                                                                size="mini"
                                                                color="teal"
                                                                disabled={
                                                                    yaEvaluado
                                                                }
                                                                onClick={
                                                                    yaEvaluado
                                                                        ? undefined
                                                                        : () => {
                                                                            leerIngresoCab(
                                                                                item.id
                                                                            );
                                                                            leerTestEvaluacion(
                                                                                item.id
                                                                            );
                                                                            setModal(
                                                                                true
                                                                            );
                                                                            evaluacionCab(
                                                                                item
                                                                            );
                                                                        }
                                                                }
                                                            >
                                                                <Icon
                                                                    name="edit outline"
                                                                    style={{
                                                                        margin: 0,
                                                                    }}
                                                                />
                                                            </Button>
                                                        </span>
                                                    }
                                                />
                                            </Table.Cell>

                                            {/* EJECUTAR / GESTIONAR */}
                                            <Table.Cell textAlign="center">
                                                <Popup
                                                    content={
                                                        esGarantiaExterna
                                                            ? "Gestionar garantía externa"
                                                            : puedeEjecutar
                                                                ? "Ejecutar garantía"
                                                                : "Primero evaluar"
                                                    }
                                                    trigger={
                                                        <span>
                                                            <Button
                                                                compact
                                                                icon
                                                                size="mini"
                                                                color={
                                                                    esGarantiaExterna
                                                                        ? "violet"
                                                                        : puedeEjecutar
                                                                            ? "green"
                                                                            : "grey"
                                                                }
                                                                disabled={
                                                                    !puedeEjecutar
                                                                }
                                                                as={
                                                                    puedeEjecutar
                                                                        ? Link
                                                                        : undefined
                                                                }
                                                                to={
                                                                    puedeEjecutar
                                                                        ? esGarantiaExterna
                                                                            ? `/gestiongarantiaexterna/${item.id}`
                                                                            : `/ejecutargarantia/${item.id}`
                                                                        : undefined
                                                                }
                                                            >
                                                                <Icon
                                                                    name={
                                                                        esGarantiaExterna
                                                                            ? "shipping fast"
                                                                            : "play circle"
                                                                    }
                                                                    style={{
                                                                        margin: 0,
                                                                    }}
                                                                />
                                                            </Button>
                                                        </span>
                                                    }
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}

                                {(!asignarOrde ||
                                    asignarOrde.length === 0) && (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="11"
                                                textAlign="center"
                                                style={{
                                                    padding: 28,
                                                    color: "#6b7280",
                                                }}
                                            >
                                                <Icon
                                                    name="inbox"
                                                    color="grey"
                                                    size="large"
                                                />
                                                <div style={{ marginTop: 6 }}>
                                                    No tienes evaluaciones asignadas.
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                            </Table.Body>
                        </Table>
                    </div>
                </Segment>

                {/* ============================================================
                MODAL EVALUACIÓN
            ============================================================ */}
                <ModalPdf estado={modal} cambiarEstado={setModal}>
                    {mostrarDet.length > 0 && (
                        <Contenido
                            style={{
                                maxHeight: "450px",
                                overflowY: "auto",
                            }}
                        >
                            <Header
                                as="h2"
                                color="teal"
                                textAlign="center"
                                style={{ margin: 0 }}
                            >
                                <Icon name="clipboard check" />
                                Evaluación Técnico
                            </Header>

                            <Table celled structured compact="very">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell rowSpan="2">
                                            N
                                        </Table.HeaderCell>
                                        <Table.HeaderCell rowSpan="2">
                                            Item
                                        </Table.HeaderCell>
                                        <Table.HeaderCell
                                            colSpan="3"
                                            textAlign="center"
                                        >
                                            Orden Ingreso
                                        </Table.HeaderCell>
                                        <Table.HeaderCell
                                            colSpan="2"
                                            textAlign="center"
                                        >
                                            Revisión Técnico
                                        </Table.HeaderCell>
                                    </Table.Row>

                                    <Table.Row>
                                        <Table.HeaderCell>Si</Table.HeaderCell>
                                        <Table.HeaderCell>No</Table.HeaderCell>
                                        <Table.HeaderCell>
                                            P. Revisión
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>Si</Table.HeaderCell>
                                        <Table.HeaderCell>No</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <TableBody>
                                    {testEvaluacion.map((item, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell
                                                style={{ fontSize: "13px" }}
                                            >
                                                {index + 1}
                                            </Table.Cell>

                                            <Table.Cell
                                                style={{
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                {item.item}
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    type="checkbox"
                                                    checked={item.valorsi}
                                                />
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    type="checkbox"
                                                    checked={item.valorno}
                                                />
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    type="checkbox"
                                                    checked={item.revision}
                                                />
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    style={{
                                                        transform:
                                                            "scale(1.2)",
                                                    }}
                                                    type="checkbox"
                                                    checked={item.valorevsi}
                                                    onChange={() =>
                                                        handleButtonClickg(
                                                            item.id,
                                                            "opcion1"
                                                        )
                                                    }
                                                />
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    style={{
                                                        transform:
                                                            "scale(1.2)",
                                                    }}
                                                    type="checkbox"
                                                    checked={item.valorevno}
                                                    onChange={() =>
                                                        handleButtonClickg(
                                                            item.id,
                                                            "opcion2"
                                                        )
                                                    }
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </TableBody>
                            </Table>

                            {testEvaluacion.filter(
                                (ic) => ic.valorevsi === true
                            ).length > 0 ? (
                                <Button
                                    icon
                                    color="red"
                                    labelPosition="right"
                                    onClick={() => guardarTest()}
                                >
                                    <Icon name="right arrow" />
                                    La orden de ingreso no es garantía, es una
                                    cotización sujeta a evaluación.
                                </Button>
                            ) : testEvaluacion.filter(
                                (ic) => ic.valorevno === true
                            ).length === testEvaluacion.length ? (
                                <Button
                                    icon
                                    color="green"
                                    labelPosition="right"
                                    onClick={() => guardarTest()}
                                >
                                    <Icon name="right arrow" />
                                    La orden de ingreso constituye como garantía.
                                </Button>
                            ) : null}
                        </Contenido>
                    )}
                </ModalPdf>

                {/* ============================================================
                MODAL DETALLE INGRESO
            ============================================================ */}
                <ModalPdf
                    estado={estadoModal}
                    cambiarEstado={setEstadoModal}
                >
                    {mostrarDet.length > 0 && (
                        <Contenido
                            style={{
                                maxHeight: "400px",
                                overflowY: "auto",
                            }}
                        >
                            <Header as="h3" color="teal">
                                <Icon name="clipboard outline" />
                                Detalle de Ingreso
                            </Header>

                            <Table celled compact="very">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                            N° Orden
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Cliente
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Teléfono
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Dirección
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Email
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {mostrarDet.map((item, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell
                                                style={{ fontWeight: 600 }}
                                            >
                                                {item.folio}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {item.entidad}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {item.telefono}
                                            </Table.Cell>
                                            <Table.Cell
                                                style={{
                                                    whiteSpace: "normal",
                                                }}
                                            >
                                                {item.direccion}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {item.correo}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>

                            {mostrarDet.map((item, index) =>
                                item.observaciones ? (
                                    <Message key={index} info>
                                        <b>Observaciones:</b>{" "}
                                        {item.observaciones}
                                    </Message>
                                ) : null
                            )}

                            <Header as="h4" color="teal">
                                Test de Ingreso
                            </Header>

                            <Table celled compact="very">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                            N
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Item Test
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Si
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            No
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <TableBody>
                                    {testIngreso.map((item, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell>
                                                {index + 1}
                                            </Table.Cell>

                                            <Table.Cell
                                                style={{
                                                    whiteSpace: "normal",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                {item.item}
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    type="checkbox"
                                                    checked={item.valorsi}
                                                />
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Input
                                                    type="checkbox"
                                                    checked={item.valorno}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </TableBody>
                            </Table>

                            {mostrarDet[0].servicio ===
                                "EVALUACION Y DIAGNOSTICO" && (
                                    <>
                                        <Header as="h4" color="teal">
                                            Test Garantía
                                        </Header>

                                        <Table celled compact="very">
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>
                                                        N
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Item Test Garantía
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell textAlign="center">
                                                        Si
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell textAlign="center">
                                                        No
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell textAlign="center">
                                                        Pendiente Evaluación
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <TableBody>
                                                {testEvaluacion.map(
                                                    (item, index) => (
                                                        <Table.Row key={index}>
                                                            <Table.Cell>
                                                                {index + 1}
                                                            </Table.Cell>

                                                            <Table.Cell
                                                                style={{
                                                                    whiteSpace:
                                                                        "normal",
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {item.item}
                                                            </Table.Cell>

                                                            <Table.Cell textAlign="center">
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={
                                                                        item.valorsi
                                                                    }
                                                                />
                                                            </Table.Cell>

                                                            <Table.Cell textAlign="center">
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={
                                                                        item.valorno
                                                                    }
                                                                />
                                                            </Table.Cell>

                                                            <Table.Cell textAlign="center">
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={
                                                                        item.revision
                                                                    }
                                                                />
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    )
                                                )}
                                            </TableBody>
                                        </Table>
                                    </>
                                )}

                            <BotonGuardar
                                onClick={() =>
                                    setEstadoModal(!estadoModal)
                                }
                            >
                                Aceptar
                            </BotonGuardar>
                        </Contenido>
                    )}
                </ModalPdf>

                {/* ============================================================
                MODAL PDF
            ============================================================ */}
                <Modal
                    open={openPdf}
                    onClose={() => setOpenPdf(false)}
                    size="large"
                    closeIcon
                >
                    <Modal.Header>
                        <Icon name="file pdf outline" color="red" />
                        Presupuesto
                    </Modal.Header>

                    <Modal.Content style={{ padding: 0 }}>
                        <PDFViewer
                            width="100%"
                            height="560"
                            style={{ border: "1px solid #ddd" }}
                        >
                            <Presupuesto
                                cabecera={cabecera}
                                falla={falla}
                                presu={presup}
                                total={total}
                                obs={obs}
                                usuario={userAdd}
                                empresa={users.emp_id}
                            />
                        </PDFViewer>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button
                            color="teal"
                            onClick={() => setOpenPdf(false)}
                        >
                            <Icon name="close" />
                            Cerrar
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Alertas
                    tipo={alerta.tipo}
                    mensaje={alerta.mensaje}
                    estadoAlerta={estadoAlerta}
                    cambiarEstadoAlerta={cambiarEstadoAlerta}
                />
            </Container>
        </Container>
    );
};

export default AsignadosTecnicos;